/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_Chat_Aria_CloseInputs */

const tr_mascot_chat_aria_close = /** @type {(inputs: Mascot_Chat_Aria_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapat`)
};

const en_mascot_chat_aria_close = /** @type {(inputs: Mascot_Chat_Aria_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const de_mascot_chat_aria_close = /** @type {(inputs: Mascot_Chat_Aria_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const ru_mascot_chat_aria_close = /** @type {(inputs: Mascot_Chat_Aria_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Mascot_Chat_Aria_CloseInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mascot_chat_aria_close = /** @type {((inputs?: Mascot_Chat_Aria_CloseInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_Chat_Aria_CloseInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mascot_chat_aria_close(inputs)
	if (locale === "de") return de_mascot_chat_aria_close(inputs)
	if (locale === "ru") return ru_mascot_chat_aria_close(inputs)
	return tr_mascot_chat_aria_close(inputs)
});